import React from 'react';
import { useTranslation } from 'react-i18next';
import './ServicesComponent.css';

const ServicesComponent = ({ img, thead, desc, idName, children }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith('en');

  return (
    <section className="service-components-section" id={idName} aria-labelledby={idName + '-heading'}>
      <div className="service-components-container">
        <div className="service-components-box">
          <div className="service-components-text">
            <p className="service-components-eyebrow">THAS MULTITECH / {isEnglish ? 'OUR SERVICES' : 'VÅRA TJÄNSTER'}</p>
            <h1 className="service-components-heading" id={idName + '-heading'}>{t(thead)}</h1>
            <p className="service-components-paragraph">{t(desc)}</p>
            {children}
            <div className="service-components-actions">
              <a className="service-quote-link" href="#contact">
                {isEnglish ? 'Request a quote' : 'Begär offert'} <span aria-hidden="true">↗</span>
              </a>
              <p className="service-components-note">
                {isEnglish
                  ? 'Tell us about your idea, requirements and timeline. We will help you find the next step.'
                  : 'Berätta om din idé, dina önskemål och din tidsplan. Vi hjälper dig att hitta nästa steg.'}
              </p>
            </div>
          </div>
          <div className="service-components-image-container">
            <img src={img} alt={t(thead)} width="480" height="480" className="service-components-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesComponent;
